<template>
  <v-menu
    v-model="dateMenu"
    ref="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <template v-if="multiple">
        <v-combobox
          :value="formatedState"
          :label="label"
          :prepend-icon="prependIcon"
          v-on="on"
          readonly
          multiple
          chips
          small-chips
          :clearable="clearable"
          @click:clear="onClear"
        />
      </template>
      <template v-else>
        <v-text-field
          :value="formatedState"
          :label="label"
          :prepend-icon="prependIcon"
          v-on="on"
          readonly
          :clearable="clearable"
          @click:clear="onClear"
        />
      </template>
    </template>
    <v-date-picker
      :first-day-of-week="firstDayOfWeek"
      :locale="localeCalc"
      :multiple="multiple"
      :value="statePicker"
      :min="min"
      :max="max"
      @input="onDatePickerInput"
      :disabled="disabled"
      :allowed-dates="allowedDates"
      show-current
      show-week
      scrollable
    >
      <template v-if="multiple">
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="onCancel">{{$t('cancel_btn')}}</v-btn>
        <v-btn flat color="primary" @click="onOK">{{$t('okay_btn')}}</v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>

<i18n>
{
  "de" : {
    "cancel_btn" : "Abbrechen",
    "okay_btn" : "OK",
    "today_text" : "heute"
  },
  "en" : {
    "cancel_btn" : "Cancel",
    "okay_btn" : "OK",
    "today_text" : "today"
  }
}
</i18n>

<script>
import { formatDates } from "@/components/mixins/FormattingMixin";

export default {
  name: "MenuDatePicker",
  props: {
    label: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: undefined
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    prependIcon: { type: String, default: "event" },
    value: {
      type: [String, Array],
      default: ""
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      type: Function,
      default: null
    }
  },
  data: () => ({
    dateMenu: false,
    statePicker: null,
    state: null
  }),
  computed: {
    localeCalc() {
      if (this.locale) {
        return this.locale;
      } else {
        return this.$i18n.locale;
      }
    },
    formatedState() {
      const dates = formatDates(this.state, this.$t("today_text"));

      if (this.multiple) {
        return dates;
      } else {
        if (dates.length == 1) {
          return dates[0];
        } else {
          return "";
        }
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.state = this.statePicker = this.normalizeValue(newVal);
      }
    }
  },
  methods: {
    doEmit() {
      this.$emit("input", this.statePicker);
      this.state = this.statePicker;
    },
    onDatePickerInput(value) {
      this.statePicker = value;
      if (!this.multiple) {
        this.dateMenu = false;
        this.doEmit();
      }
    },
    onClear() {
      this.statePicker = this.normalizeValue(null);
      this.doEmit();
    },
    onOK() {
      this.dateMenu = false;
      this.doEmit();
    },
    onCancel() {
      this.dateMenu = false;
      this.statePicker = this.state;
    },
    normalizeValue(value) {
      if (this.multiple) {
        if (value instanceof Array) {
          return value;
        } else if (typeof value == "string") {
          return [value];
        } else {
          return [];
        }
      } else {
        if (typeof value == "string") {
          return value;
        } else if (value instanceof Array && value.length > 0) {
          return value[0];
        } else {
          return "";
        }
      }
    }
  }
};
</script>
